var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getObjectFromFormData } from '../../assets/js/utils/getObjectFromEntries';
export function fetchAdditionalNewsletterSubscriptions(submitAdditionalNewslettersApiUrl, requestVerificationToken, formData, newsletterCodeName, additionalNewsletterSubscriptions) {
    return __awaiter(this, void 0, void 0, function* () {
        const formDataObject = getObjectFromFormData(formData);
        const payload = Object.assign({ newsletterCodeName,
            additionalNewsletterSubscriptions }, formDataObject);
        const response = yield fetch(submitAdditionalNewslettersApiUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': requestVerificationToken,
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw Error();
        }
        const data = yield response.json();
        return data.redirectUrl;
    });
}
